import { GetterTree } from 'vuex'
import { ReportsState } from '@/store/modules/report/types'
import { ReportModel } from '@/models/interfaces/report.model'

export const getters: GetterTree<ReportsState, any> = {
  getReports(state): ReportModel[] | null {
    return state.reports ? state.reports : null
  },
  getCompleteReports(state): ReportModel[] | null {
    if (state.reports) {
      return state.reports.filter(
        (item: ReportModel) => !item.meta.incomplete_analysis
      )
    }
    return null
  },
  getIncompleteReports(state): ReportModel[] | null {
    if (state.reports) {
      return state.reports.filter(
        (item: ReportModel) => item.meta.incomplete_analysis
      )
    }
    return null
  },
  getSubscriberReport(state): any {
    return state.subscriberReport
  },
  getLoading(state): boolean {
    return state.loading
  },
  getReport(state): any {
    return state.selectedReport
  }
}
